import React from "react";
import {
  Static,
  Background,
  AboutList,
  AboutListItem,
  AboutListTitle,
  AboutListContent,
  CTA,
} from "./Styles";
import Container from "../../components/UI/Container";
import LinkButton from "../../components/Buttons/NewButton/LinkButton";

const About = () => {
  return (
    <Static>
      <Container gutter="medium">
        <h1>
          TransConnector is a platform to Connect Hauliers, Spedition Companies
          and Cargo Owners to solve their Transport needs.
        </h1>
        <h5>
          It's a platform where you can publish your Roundtrip offers (for
          speditions) ja request for suitable co-operation on Roundtrips (for
          carriers). Get an overview of current prices on the market and contact
          speditions and carriers from all around the Europe.
        </h5>
        <h5>
          It is the easiest, cheapest and most reliable way to grow your fleet.{" "}
        </h5>
      </Container>
      <Background background="#FBFDFF" padding="2rem 0">
        <Container gutter="medium">
          <AboutList>
            <AboutListItem>
              <AboutListTitle>Roundtrip</AboutListTitle>
              <AboutListContent>
                <p>
                  The “Roundtrip Solution” is a unique feature for the logistics
                  and transportation sector, aimed to improve operational
                  efficiency between freight forwarders and hauliers. It allows
                  forwarders to book hauliers for dedicated routes, ensuring a
                  reliable and continuous flow of transportation. With these
                  long-term partnerships, hauliers benefit from stable
                  engagements and fewer unused vehicles.
                </p>
                <p>
                  You can easily find suitable routes, compare prices, add them
                  to your favourites list and contact the carrier right from the
                  offer.
                </p>
                <p>
                  TransConnector gives you the opportunity to manage your
                  logistics more efficiently and with lower cost.
                </p>
              </AboutListContent>
            </AboutListItem>
          </AboutList>
        </Container>
      </Background>
      <Container gutter="medium">
        <CTA>
          <h4>You can easily find plan that matches your business needs.</h4>
          <h3>Prices start at 49,90€ per month.</h3>
          <LinkButton to="/sign-up">Join now</LinkButton>
        </CTA>
      </Container>
    </Static>
  );
};

export default About;
